var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{attrs:{"options":{
        mode: 'htmlmixed',
        lineNumbers: true,
        lineWrapping: true,
        extraKeys: {'Ctrl-Space': 'autocomplete'}
    },"value":_vm.code},on:{"change":_vm.updateCode}})}
var staticRenderFns = []

export { render, staticRenderFns }